export default __webpack_public_path__ + "static/media/product-banner5.64065810.png";